// extracted by mini-css-extract-plugin
export var avatarContainer = "_1a-0";
export var avatarTypingWave = "_1a-i";
export var gray = "_1a-f";
export var green = "_1a-c";
export var icon = "_1a-9";
export var image = "_1a-1";
export var lg = "_1a-6";
export var md = "_1a-5";
export var presenceDot = "_1a-b";
export var red = "_1a-d";
export var sm = "_1a-4";
export var status = "_1a-a";
export var typingDot = "_1a-h";
export var typingPill = "_1a-g";
export var xl = "_1a-7";
export var xs = "_1a-3";
export var xxl = "_1a-8";
export var xxs = "_1a-2";
export var yellow = "_1a-e";